import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { api } from '@app/utils/api';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { ManagerQuarterlyPlanDto } from '../types';

type Params = {
  managerId: number;
  year: number;
  quarter: number;
  plan: string;
  isBonusActive?: boolean;
};

export const updateManagerQuarterlyPlan = async ({
  managerId,
  year,
  quarter,
  plan,
  isBonusActive = false,
}: Params) => {
  const { data } = await api.post<ManagerQuarterlyPlanDto>(
    `${PANEl_BASE_URL}/general/manager-plan-quarter/create_by_params/`,
    {
      manager: managerId,
      year,
      quarter,
      plan,
      is_bonus_active: isBonusActive,
    }
  );

  return data;
};

export const useUpdateManagerQuarterlyPlan = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateManagerQuarterlyPlan,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
